import { render, staticRenderFns } from "./heim-table.vue?vue&type=template&id=51b83e87&scoped=true&"
import script from "./heim-table.vue?vue&type=script&lang=js&"
export * from "./heim-table.vue?vue&type=script&lang=js&"
import style0 from "./heim-table.vue?vue&type=style&index=0&id=51b83e87&scoped=true&lang=css&"
import style1 from "./heim-table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b83e87",
  null
  
)

component.options.__file = "heim-table.vue"
export default component.exports